import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=a77a3f4a&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"
import style0 from "./Type.vue?vue&type=style&index=0&id=a77a3f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a3f4a",
  null
  
)

export default component.exports